<template>
    <div class="chat">
        <v-side-swipe-bar :show="$store.getters.barChat.value" sbName="chat"
            @hide="$emit('hide')" :draggable="true" :outsideDisabed="true" :disabledFooter="!!contact"
            @pin="handlePin($event)"
        >
            <div class="qpay__header" slot="header" style="overflow: visible;">
                <button class="button button__no_min-width button_type_icon" v-if="contact" @click = "handleClickBack">
                    <svg width="16" height="16">
                        <use href="#icon-arrow-left-crumbs"></use>
                    </svg>
                </button>
                <p> Чат </p>
                <p class="subtitle" v-if="this.contact" style="margin-left: 7px;" :title="this.contact.platform_title">
                    {{this.contact.platform_title}}
                </p>
                <v-chat-switcher v-model="this.contact" :phone="contact.client.phone" v-if=" isCanChooseChat && this.contact && this.contact.chat_list" @click="handleClickChatSwitcher" />
            </div>
            
            <template slot="body" >
                <v-chat-contacts @click="handleClickContact" v-if="!contact" />
                <v-chat-messanger v-else 
                    ref="messanger"
                    v-model="contact" 
                    @chatStatusChange="handleChatStatusChange" 
                    @update="handleChatUpdate($event)"
                    @callendchatmodal = "isEndChat = true"
                    :image="image"/> 
                    
            </template>
            <!-- <div slot="footer" v-if="!contact">
                <v-chat-footer v-model="footerCounter" />
            </div> -->
        </v-side-swipe-bar>
        <v-end-chat-modal v-if="isEndChat" @clickCategory="handleClickCategory"/>
    </div>
</template>

<script>
import vChatContacts from '../../chat/chatContacts';
import vChatFooter from '../../chat/chatFooter';
import vSideSwipeBar from '../../global/SideSwipeBar'
import vChatMessanger from '../../chat/chatMessanger.vue' 
import { mapActions } from 'vuex'
import vEndChatModal from '@components/global/vEndChatModal';
import vChatSwitcher from "./components/ChatSwitcher.vue"

import api from '@api';
export default {
    name: 'vChat',
    components: {
        vSideSwipeBar,
        vChatContacts,
        vChatFooter,
        vChatMessanger,
        vEndChatModal,
        vChatSwitcher
    },
    props: {
      selected: {
        type: [Object, Boolean],
        default: () => {}
      }  
    },
    data() {
        return {
            footerCounter: null,
            contact: null,
            image: null,
            isEndChat: false,
            isCanChooseChat: null
        }
    },
    mounted() {
        this.getFooterCounters().then( res=>{
            this.footerCounter = res
        })
        this.getIsCanChooseChat().then(res=>{
            this.isCanChooseChat = res
        })
        const _this = this
        document.addEventListener('keydown', e=>{ _this.watchKeyPress(e) })
        if(this.selected) {
            const {contact} = this.selected
            this.image = contact.logo || contact.image
            this.getChatDetail(contact.id).then(response=>{
                this.contact = response
                if(contact.message_id) this.contact.message_id = contact.message_id
            })
        }
    },
    beforeDestroy() {
        this.RESET_TAB()
    },
    methods: {
        ...mapActions([
            'SET_PIN',
            'RESET_TAB',
            'SET_BAR'
        ]),
        watchKeyPress(key) {
            if(key.srcElement.tagName == 'TEXTAREA' || key.srcElement.tagName == 'INPUT') return
            if(key.code == 'Backspace' && this.contact) {
                this.handleClickBack()
            }
        },
        handleClickChatSwitcher(event) {
            //const temp = this.contact
            const newContact = {
                id: event.chat_id,
                chat_history_id: this.contact.chat_history_id
            }
            this.contact = null
            
            this.$nextTick(() => {
                this.handleClickContact(newContact)
            })

        },
        handleClickContact(contact) {
            console.warn(contact);
            
            this.image = contact.logo || contact.image
            const chat_history_id =  contact.chat_history_id 
            this.getChatDetail(contact.id).then(response=>{
                this.contact = response
                if(chat_history_id) this.contact.chat_history_id = chat_history_id
            })
        },
        handleChatUpdate(action) {
            this.getChatDetail(this.contact.id).then(response=>{
                if(action == 'assign' ) { 
                    this.contact = null
                    this.$nextTick(() =>{
                        this.contact = response
                    })
                } else {
                    this.contact = null
                }
            })
        },
        handleClickBack() {
            this.contact = null
            this.image = null
        },
        handleChatStatusChange(e) {
            this.getFooterCounters().then( res=>{
                this.footerCounter = res
            })
        },
        getFooterCounters() {
            return api.chat.getCounts().then(response=>{
                return response
            }).catch(error=>{
                this.$toast.error(error.message)
            }).finally(e=>{
                this.isloading = false
            })
        },
        getChatDetail(id) {
            const paylaod = {
                id
            }
            return api.chat.getChatDetail(paylaod,'', 'post').then(response=>{
                return response
            }).catch(error=>{
                this.$toast.error(error.message)
            }).finally(e=>{
                this.isloading = false
            })
        },
        handlePin(bool) {
            this.SET_PIN({name:'chat', val:bool})
            this.$emit('pin', bool)
        },
        handleClickCategory(category) {
            const messanger = this.$refs.messanger
            messanger.handlePopupClose(category.id)
            this.isEndChat = false
        },
        getIsCanChooseChat () {
            return api.profile.info().then(res=>{
                return res.response.can_choose_chat
            }).catch(error=>{
                this.$toast.error(error.message)
            }).finally(e=>{
                this.isloading = false
            })
        },
        handleClickChangeChat() {
            console.log('handleClickChangeChat');
        }
    },
}
</script>
<style lang="scss" scoped>
::v-deep {
    .sideBar__header {
        position: relative;
    }
    .dropList{
        margin-top: 0;
        width: 100%;
        p{
            font-size: 14px;
            line-height: 1;
        }
    } 
}
</style>